import { render, staticRenderFns } from "./date-form.vue?vue&type=template&id=53d986ea&scoped=true&"
import script from "./date-form.vue?vue&type=script&lang=js&"
export * from "./date-form.vue?vue&type=script&lang=js&"
import style0 from "./date-form.vue?vue&type=style&index=0&id=53d986ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d986ea",
  null
  
)

export default component.exports